import {ChangeEvent, FC, useEffect, useState} from 'react';
import {
    Box,
    Card,
    CardHeader,
    Divider,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Typography
} from '@mui/material';
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import ModalUserInfo from "./ModalUserInfo";
import {User} from "../../../models/user";
import ModalEditCoinUser from "./ModalEditCoinUser";

interface Filters {
    status?: number;
    keyword?: string;
}

const RecentOrdersTable: FC = () => {
    const [currentUser, setCurrentUser] = useState<User>();
    const [users, setUsers] = useState<Array<User>>([]);
    const [openModalUser, setOpenModalUser] = useState<boolean>(false);
    const [openModalUserEdit, setOpenModalUserEdit] = useState<boolean>(false);
    const [page, setPage] = useState<number>(0);
    const [total, setTotal] = useState<number>(0);
    const [limit, setLimit] = useState<number>(10);
    const [filters, setFilters] = useState<Filters>({
        status: -1,
        keyword: ""
    });

    const handleStatusChange = (e: ChangeEvent<HTMLInputElement>): void => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            keyword: e.target.value
        }));
    };

    const getUser = (page: number, limit: number, filters: Filters) => {
        const headers = {'token': JSON.parse(localStorage.getItem("token")).token}
        fetch(`${process.env.REACT_APP_DOMAIN}/api/user/coin?page=${page}&pageSize=${limit}&keyword=${filters.keyword}`, {headers})
            .then(async response => {
                if (response.status == 401) {
                    localStorage.removeItem("token");
                    window.location.href = '/';
                } else {
                    const data = await response.json();
                    setUsers(data.users)
                    setTotal(data.count)
                }
            })
    }
    useEffect(() => {
        getUser(page, limit, filters);
    }, [filters, page, limit]);

    const handlePageChange = (event: any, newPage: number): void => {
        setPage(newPage);
    };

    const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
        setLimit(parseInt(event.target.value));
    };


    return (
        <Card>
            <ModalUserInfo open={openModalUser} setOpen={setOpenModalUser} user={currentUser}/>
            <ModalEditCoinUser open={openModalUserEdit} setOpen={setOpenModalUserEdit} refreshTable={() => {
                getUser(page, limit, filters)
            }} user={currentUser}/>
            <CardHeader
                action={
                    <div>
                        <Box
                            component="form"
                            sx={{
                                '& .MuiTextField-root ': {m: 1, width: '25ch'},
                                '& .MuiButton-root': {m: 2, width: '15ch'},
                            }}
                            noValidate
                            autoComplete="off"
                        >
                            <div>
                                <TextField
                                    id="outlined-select-currency"
                                    label="Tìm kiếm"
                                    value={filters.keyword}

                                    onChange={handleStatusChange}
                                >

                                </TextField>
                            </div>
                        </Box>
                    </div>
                }
                title="Quản lý người dùng"
            />
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>User ID</TableCell>
                            <TableCell>Tên FB</TableCell>
                            <TableCell>VCT</TableCell>
                            <TableCell>VCT đợi duyệt</TableCell>
                            <TableCell>Trace Key</TableCell>
                            <TableCell align="center">#</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {users.map((cryptoOrder) => {

                            // @ts-ignore
                            // @ts-ignore
                            return (
                                <TableRow
                                    hover
                                    key={cryptoOrder.id}
                                >
                                    <TableCell>
                                        <Typography
                                            variant="body1"
                                            color="text.primary"
                                            gutterBottom
                                            noWrap
                                        >
                                            {cryptoOrder.id}
                                        </Typography>
                                        {/*<Typography variant="body2" color="text.secondary" noWrap>*/}
                                        {/*    {format(cryptoOrder.orderDate, 'MMMM dd yyyy')}*/}
                                        {/*</Typography>*/}
                                    </TableCell>
                                    <TableCell>
                                        <Button onClick={event => {
                                            setOpenModalUser(true);
                                            setCurrentUser(cryptoOrder)
                                        }}>
                                            {cryptoOrder.userId}
                                        </Button>
                                    </TableCell>
                                    <TableCell align="left">
                                        <Box
                                            component="img"
                                            sx={{
                                                height: 50,
                                                width: 50,
                                            }}
                                            alt=""
                                            src={cryptoOrder.image}
                                        /> <Typography
                                            variant="body1"
                                            color="text.primary"
                                            gutterBottom
                                            noWrap
                                        >
                                            {cryptoOrder.fbName}
                                        </Typography>

                                    </TableCell>
                                    <TableCell>
                                        <Typography
                                            variant="body1"
                                            fontWeight="bold"
                                            color="text.primary"
                                            gutterBottom
                                            noWrap
                                        >
                                            {cryptoOrder.balance}
                                        </Typography>

                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography
                                            variant="body1"
                                            color="text.primary"
                                            gutterBottom
                                            noWrap
                                        >
                                            {cryptoOrder.balancePending}
                                        </Typography>

                                    </TableCell>

                                    <TableCell align="left">
                                        <Typography
                                            variant="body1"
                                            color="text.primary"
                                            gutterBottom
                                            noWrap
                                        >
                                            {cryptoOrder.traceKey}
                                        </Typography>

                                    </TableCell>
                                    <TableCell align="right">

                                        <Stack direction="row" spacing={2}><Button color="success" size="small"
                                                                                   variant="outlined"
                                                                                   onClick={event => {
                                                                                       setOpenModalUserEdit(true);
                                                                                       setCurrentUser(cryptoOrder);
                                                                                   }}>
                                            Sửa điểm
                                        </Button>
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <Box p={2}>
                <TablePagination
                    component="div"
                    count={total}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleLimitChange}
                    page={page}
                    rowsPerPage={limit}
                    rowsPerPageOptions={[5, 10, 25, 30]}
                />
            </Box>
        </Card>
    )
};
export default RecentOrdersTable;
